import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e617758"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal is-active"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "notification is-warning" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "block" }
const _hoisted_7 = { class: "block" }
const _hoisted_8 = { class: "buttons" }
const _hoisted_9 = { class: "icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.t("sthwentwrong")), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.t("formaterror")), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.t("checkformat")), 1),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                class: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              }, [
                _createElementVNode("span", _hoisted_9, [
                  _createVNode(_component_font_awesome_icon, { icon: "times" })
                ]),
                _createElementVNode("span", null, _toDisplayString(_ctx.t("close")), 1)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}